import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SPOTS_TOTAL, useWaitlistCount } from '../lib/waitlist';
export function ScarcityCard() {
  const {
    count
  } = useWaitlistCount();
  const reserved = count === null ? null : Math.min(count, SPOTS_TOTAL);
  const pct = reserved === null ? 0 : Math.round(reserved / SPOTS_TOTAL * 100);
  return <div className="border border-white/[0.16] border-t-[3px] border-t-camel bg-white/[0.04] px-6 py-7 text-center" data-id="element-124">
      <p className="mb-4 font-mono text-[11px] uppercase tracking-[1.5px] text-white/55" data-id="element-125">
        Primera tanda · Cupos limitados
      </p>

      <div className="font-display text-[clamp(40px,7vw,64px)] leading-none text-white tabular-nums" data-id="element-126">
        {reserved === null ? '—' : reserved.toLocaleString('es-AR')}
        <span className="ml-1 font-display text-[clamp(18px,3vw,24px)] text-white/45" data-id="element-127">
          / {SPOTS_TOTAL}
        </span>
      </div>
      <p className="mt-2 font-mono text-[11px] uppercase tracking-[1px] text-white/45" data-id="element-128">
        cupos reservados
      </p>

      <div className="mt-4 h-2 w-full overflow-hidden bg-espresso-2" role="progressbar" aria-valuemin={0} aria-valuemax={SPOTS_TOTAL} aria-valuenow={reserved ?? 0} aria-label="Cupos reservados de la primera tanda" data-id="element-129">
        <div className="h-full bg-camel transition-[width] duration-700 ease-out" style={{
        width: `${pct}%`
      }} data-id="element-130" />
      </div>

      <p className="mt-4 text-[12.5px] font-semibold text-white/55" data-id="element-131">
        Cuando se agota la primera tanda, cerramos la lista.
      </p>

      <div className="mt-5 flex items-center justify-center gap-2 border-t border-white/[0.12] pt-4" data-id="element-132">
        <GiftIcon className="h-4 w-4 flex-shrink-0 text-camel-light" aria-hidden="true" data-id="element-133" />
        <p className="text-[12px] font-semibold text-camel-light" data-id="element-134">
          + Regalo de bienvenida para los primeros
        </p>
      </div>
    </div>;
}